import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';

import { cardStyles as styles } from './index';

const InvoicingReport = ({ data }) => {
  const [saleId, setSaleId] = useState(null);
  const [buyerId, setBuyerId] = useState(null);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'invoicing-report',
      params: { 'saleId': saleId, 'buyerId': buyerId }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Invoicing Report</Text>
      <Text style={styles.label}>Sale:</Text>
      <select style={styles.select} onChange={(e) => setSaleId(e.target.value)}>
        <option value="">Select Sale</option>
        {data.sales?.map(sale => (
          <option key={sale.id} value={sale.id}>{sale.name}</option>
        ))}
      </select>
      <Text style={styles.label}>Buyer: (optional)</Text>
      <select style={styles.select} onChange={(e) => setBuyerId(e.target.value)}>
        <option value="">Select Buyer</option>
        {data.buyers?.map(buyer => (
          <option key={buyer.id} value={buyer.id}>
            {buyer.fullDisplayName}
          </option>
        ))}
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default InvoicingReport;
